import React from 'react';
import { useRef } from "react";
import { useState } from 'react';
import { useEffect } from 'react';
import '../../../cssFiles/productPages.scss';
import Footer from '../../layouts/footer';
import Headers from '../../layouts/header';
import { StatisticCard } from '@ant-design/pro-components';
import 'antd/dist/reset.css';
import Celebration from '../../layouts/celebration';
// import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaAngleRight, FaAngleLeft} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Navigation } from "swiper/modules";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import ProductCards from '../productComparison/productCards';
import { leadServiceHelper } from '../../../services/leadServices';

const features = [
  {
    icon: '/images/premium/flexible.png',
    title: 'Multibagger Hyper Growth Strategy',
    desc: 'Fair valued stocks with hyper growth. Future Industry leaders with long term macro drivers.'
  },
  {
    icon: '/images/premium/no-profits-sharing.png',
    title: 'No Yearly Fee!',
    desc: "Don't pay annual fees for Multibaggers! One-time fee Rs 25K over 2-3 years."
  },
  {
    icon: '/images/premium/performance_gaurantee_orange.png',
    title: 'Service Guarantee',
    desc: 'Service will be active until 5 research calls are delivered. No annual or quarterly charges.'
  },
  {
    icon: '/images/premium/risk_orange4.png',
    title: 'Risk Management',
    desc: 'No penny or micro cap stocks! High quality small-mid cap stocks with very low downside risk. Capital diversification into 5 industries.'
  },
  {
    icon: '/images/premium/360research_reports_ornage.png',
    title: '360° Research Reports',
    desc: '7-8 pager analysis of macro, fundamental, news and every factor influencing stock price.'
  },
  {
    icon: '/images/premium/Research-Desk-Access-new.png',
    title: 'Research Desk Access',
    desc: 'Get additional insights on research reports & quarterly portfolio updates from the research desk.'
  }
];

const plans = [
  {
    title: 'p360° Premium',
    popular: true,
    returns: '25% returns objective* over ~12 months',
    brokerage: ' ',
    price: '₹20000 + GST',
    timeLimit: 'Service active until returns delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Balanced Strategy',
    guarantee: 'Service Guarantee',
    research: 'Research Desk Access',
    mainPage:  '/products/premium' 
  },
  // {
  //   title: 'p360° Momentum',
  //   returns: '5-10% returns objective* over 2-6 Weeks',
  //   price: '₹20000 + GST',
  //   timeLimit: 'No Time Limit',
  //   stocks: '20 Stocks',
  //   button: 'Learn More',
  //   strategy: 'Momentum Strategy',
  //   guarantee: 'No Service Guarantee',
  //   research: '360° Research Note (1 Page)',
  //   mainPage:  '/products/momentum' 

  // },
  {
    title: 'p360° Mid Term',
    returns: '20-25% returns objective* over 6-9 months',
    price: '₹15000 + GST',
    timeLimit: 'Service active until 10 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (4 Pages)',
    mainPage:  '/products/midterm' 
  },
  {
    title: 'p360° Long Term',
    returns: 'More than 50% returns objective* over 1-2 years!',
    price: '₹15000 + GST',
    timeLimit: 'Service active until 5 stocks delivered',
    stocks: ' ',
    button: 'Learn More',
    strategy: 'Growth+Value Strategy',
    guarantee: 'No Service Guarantee',
    research: '360° Research Reports (8 Pages)',
    mainPage:  '/products/longterm'  
  },
  // {
  //   title: 'p360° Multibagger',
  //   popular: false,
  //   returns: 'More than 100% returns objective* over 2-3 years',
  //   price: '₹25000 + GST',
  //   timeLimit: 'Service active until 5 stocks delivered',
  //   stocks: ' ',
  //   button: 'Learn More',
  //   strategy: 'Balanced Strategy',
  //   guarantee: 'Service Guarantee',
  //   research: 'Research Desk Access',
  //   mainPage:  '/products/multibagger' 
  // },
];

const researchCalls = [
  {
    name: 'RattanIndia Ent',
    entry: '₹ 40.8',
    exit: '₹ 65.5',
    entryDate:'6th Mar 2025',
    exitDate:'11 Jun 2025',
    returns: '60.54%',
    trend: 60.54
  },
  {
    name: 'CDSL',
    entry: '₹ 1108',
    exit: '₹ 1788',
    entryDate:'28th Feb 2025',
    exitDate:'10 Jun 2025',
    returns: '61.7%',
    trend: 61.7
  },
  {
    name: 'Techno Electric',
    entry: '₹ 1077',
    exit: '₹ 1600',
    entryDate:'9th Apr 2025',
    exitDate:'27th Jun 2025',   
    returns: '48.56%',
    trend: 48.56
  },
  {
    name: 'Apollo Micro Sys Ltd',
    entry: '₹ 121',
    entryDate:'13th Jan 2025',
    exitDate:'16th May 2025',    
    exit: '₹ 140',
    returns: '19.6%',
    trend: 19.6
  },

  {
    name: 'Dredging Corp Ltd',
    entry: '₹ 580',
    exit: '₹ 696',
    entryDate:'01 Apr 2025',
    exitDate:'19 May 2025',    
    returns: '20%',
    trend: 20
  },
    {
    name: 'Anantraj Ltd',
    entry: '₹ 306',
    exit: '₹ 334',
    entryDate:'18 Jan 2024',
    exitDate:'05 Feb 2024',    
    returns: '9%',
    trend: 	9
  },
  {
    name: 'Shakti pump',
    entry: '₹ 1149',
    exit: '₹ 1480',
    entryDate:'18 Jan 2024',
    exitDate:'30 Jan 2024',    
    returns: '29%',
    trend: 29
  },
  {
    name: 'PNB',
    entry: '₹ 130',
    exit: '₹ 122',
    entryDate:'20 Feb 2024',
    exitDate:'5 Mar 2024',    
    returns: '-6%',
    trend: -6
  }
];

const Multibagger = () => {


    const [form, setForm] = useState({ countryCode: '', mobile: ''});
    const [submitted, setSubmitted] = useState(false);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperReady, setSwiperReady] = useState(false);
    const [productFeatures, setProductFeatures] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();



    const handleFormChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
      // if(e.target.value && e.target.value.length <11){
      //   setForm({ ...form, [e.target.name]: e.target.value });
      // }
    };
    useEffect(() => {
      // Ensure Swiper re-renders after refs are attached
      window.scrollTo(0, 0);
      setSwiperReady(true);
      if (window.innerWidth <= 500) {
        setProductFeatures(features.slice(0, 4));
      } else {
        setProductFeatures(features);
      }
    }, []);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        // // You can add your submit logic here (API call, etc.)
        // setTimeout(() => setSubmitted(false), 2000);
        // setForm({ name: '', mobile: '', email: '' });
        // navigate('/products/premium/thankyou',{ state: { product: 'premium' } });

        leadServiceHelper.submitMobileNumberService(form,()=>{
          setTimeout(() => setSubmitted(false), 2000);
          setForm({ name: '', mobile: '', email: '' });
          // navigate('/products/premium/thankyou',{ state: { product: 'premium' } });
        })
    };

    const toggleExpand = () => {
      if (!expanded) {
        setProductFeatures(features);
        setExpanded(!expanded);
      }else {
        setProductFeatures(features.slice(0, 4));
        setExpanded(!expanded);
        // setTimeout(2000,()=>{document.getElementById('expand_collapse').scrollIntoView({ behavior: 'smooth' })});
      }
    };

    useEffect(() => {
        document.title = "Niveza - Multibagger Plan";
        // Load Elfsight script only once
        const scriptId = 'elfsight-platform-script';
        if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        document.body.appendChild(script);
        }
    }, []);


    return (
        <>
            <Headers/>
            <Celebration/>
            {window.innerWidth >= 500 ?
            <div className="top-price">
              <div className="premium-footer">
                  <div className="premium-price">
                      {/* <span style={{fontFamily:'bold',color:'white'}}>Start with </span> */}
                      <div><span className="premium-price-value">₹ 25,000</span> <span className="premium-price-gst">+GST</span></div>
                  </div>
                  <div className="premium-contact-form-container" >
                      <div className="premium-form-section" >
                        <form className="premium-form" onSubmit={handleFormSubmit}>
                          <div>
                            <input
                              type="tel"
                              name="mobile"
                              placeholder= {window.innerWidth <= 500 ? "Mobile Number" : "Enter mobile number"}  
                              className= 'premium-form-input'
                              value={form.mobile}
                              onChange={handleFormChange}
                              pattern="^(?:\d-?){10}$"
                              required
                              onInvalid={e => e.target.setCustomValidity("Please enter a valid 10‑digit mobile number")} 
                              onInput={e => e.target.setCustomValidity("")}
                            />
                            <button type="submit" disabled={submitted} >
                              {submitted ? 'Submitted!' : 'Get a call back'}
                            </button>
                          </div>
                        </form>
                      </div>
                      <span className='cta_or'>Or</span>
                      <div className="premium-contact">
                        {window.innerWidth <= 500 ? <span style={{fontFamily:'bold'}}>Click to call</span> : <></>}  
                        <span className="premium-contact-phone">{window.innerWidth <= 500 ? <a href="tel:+919607527770">+91-96075-27770</a> : <span style={{fontFamily:'bold',color:'white'}}>+91-96075-27770</span>} </span>
                      </div>
                  </div>
              </div>
            </div> : ''}
            <div  className="premium-container">
                <div className="premium-header">
                  <img src="/images/premium/logo_p360.png" alt="Premium" className="premium-logo" />
                  <span className="premium-title">
                      More than <span className='highlight'>100% returns objective<sup>*</sup> over 2-3 years</span>
                      {/* 25% Returns Objective<sup>*</sup> Over 12 Months */}
                  </span>
                </div>
                <div className="premium-features">
                {productFeatures.map((f, i) => (
                    <div className="premium-feature" key={i}>
                    <img src={f.icon} alt={f.title} className="premium-feature-icon" />
                    <div>
                        <div className="premium-feature-title">{f.title}</div>
                        <div className="premium-feature-desc">{f.desc}</div>
                    </div>
                    </div>
                ))}
                </div>
                {
                  window.innerWidth <= 500 ?
                    <div onClick={toggleExpand} className="expand-text"> {expanded? '<<Less' : 'Click to see more>>'}</div> : ' '
                }

                <div style={{ paddingBottom:'8px', marginTop:'40px' }}>
                  <span style={{display: 'block',width: '100%',textAlign: 'center',fontWeight:'bold',color:'black',fontSize:'clamp(1.3rem, 4vw, 1.6rem)'}}>Latest Research <span className='highlight'>Calls You Missed</span></span>
                </div>

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <div ref={prevRef} style={{ cursor: 'pointer' }}>
                    {/* <BiArrowFromRight size={44} /> */}
                    <button
                      style={{
                        backgroundColor: "#3cb371",
                        border: "none",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <FaAngleLeft color="white" size={28} />
                    </button>  
                  </div>
                  {swiperReady && (
                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={56}
                      slidesPerView={"auto"}
                      grabCursor={true}
                      style={{ padding: "1rem" }}

                      loop={true}
                      navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                      }}
                      onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                      }}
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        600: { slidesPerView: 2 },
                        900: { slidesPerView: 3 },
                        1200: { slidesPerView: 3 },
                      }}
                    >
                      {researchCalls.map((call, i) => (
                        <SwiperSlide key={i} className="slider-card" >
                          <StatisticCard
                            className="statistic-card"
                            style={{  border: '2px solid #3cb371' }}
                          >
                            <div className='statsDesc'>
                              <div>
                                {
                                window.innerWidth >= 500 ?
                                  <>
                                    <div style={{ textAlign:'center'}}><span style={{ fontWeight: 'bold',fontSize:'18px' }}>{call.name}</span></div>
                                    <br></br>
                                    <div className='returns'>Returns: &nbsp;&nbsp;&nbsp;<b>{call.returns}{call.trend>0?<FaArrowUp color='green'/>:<FaArrowDown color='red'/>}</b></div>
                                    <div>Entry Price: &nbsp;&nbsp; <b>{call.entry}</b></div>
                                    <div>Entry Date: &nbsp;&nbsp;&nbsp; <b>{call.entryDate}</b></div>
                                    <div>Exit Price:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <b>{call.exit}</b></div>
                                    <div>Exit Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>{call.exitDate}</b></div>
                                  </>:
                                  <>
                                    <div style={{ textAlign:'center'}}><span style={{ fontWeight: 'bold',fontSize:'18px' }}>{call.name}</span></div>
                                    <br></br>
                                    <div className='returns'>Returns:&nbsp;&nbsp;<b>{call.returns}{call.trend>0?<FaArrowUp color='green'/>:<FaArrowDown color='red'/>}</b></div>
                                    <div>Entry Price:&nbsp;<b>{call.entry}</b></div>
                                    <div>Entry Date:&nbsp;<b>{call.entryDate}</b></div>
                                    <div>Exit Price:&nbsp;&nbsp;&nbsp;<b>{call.exit}</b></div>
                                    <div>Exit Date:&nbsp;&nbsp;&nbsp;<b>{call.exitDate}</b></div>
                                  </>
                                }
                              </div>
                            </div>
                          </StatisticCard>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                  <div ref={nextRef} style={{ cursor: 'pointer' }}>
                    {/* <BiArrowFromLeft size={44} /> */}
                    <button
                      style={{
                        backgroundColor: "#3cb371",
                        border: "none",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <FaAngleRight color="white" size={28} />
                    </button>   
                  </div>
                </div>



                {/* <div>
                  <div  className="google-reviews-section">
                      <div className="elfsight-app-28d4333b-031d-43dd-a616-8a3ae9781d51" data-elfsight-app-lazy></div>
                  </div>
                </div>  */}

              {/* <script src="https://elfsightcdn.com/platform.js" async></script> */}
              <div style={{marginRight:"21px",marginLeft:"26px"}}>
                <div class="elfsight-app-b0efdf6e-91e0-446f-869a-399f7905e1fc" data-elfsight-app-lazy></div>
              </div>

              {window.innerWidth <= 500 ?
                <div className="premium-footer">
                    <div className="premium-price">
                        <span>Start with </span>
                        <div><span className="premium-price-value">₹ 25,000</span> <span className="premium-price-gst">+GST</span></div>
                    </div>
                    <div className="premium-contact-form-container" >
                        <div className="premium-form-section" >
                            <form className="premium-form" onSubmit={handleFormSubmit}>
                              <div>
                                <input
                                  type="tel"
                                  name="mobile"
                                  placeholder={window.innerWidth <= 500 ? "Mobile Number" : "Enter mobile number"}
                                  className="premium-form-input"
                                  value={form.mobile}
                                  onChange={handleFormChange}
                                  pattern="^(?:\d-?){10}$"
                                  required
                                />
                                <button type="submit" disabled={submitted}>
                                  {submitted ? "Submitted!" : "Get a call back"}
                                </button>
                              </div>
                            </form>
                        </div>
                        <span className='cta_or'>Or</span>
                        <div className="premium-contact">
                            {window.innerWidth <= 500 ? <span style={{fontFamily:'bold'}}>Click to call</span> : <></>}  
                            <span className="premium-contact-phone">{window.innerWidth <= 500 ? <a href="tel:+919607527770">+91-96075-27770</a> : <span style={{fontFamily:'bold',color:'black'}}>+91-96075-27770</span>} </span>
                        </div>
                    </div>
                </div>: ''}
              <div className="video-reviews-header">
                <h2>
                  Want to Explore <span>Other Products?</span>
                </h2>
                {/* <p>Real feedback from our satisfied customers</p> */}
              </div>
              <ProductCards plans={plans}/>                
            </div>
            <p style={{textAlign: 'center',fontFamily:'bold',color:'grey',fontSize:'0.8rem'}}>*Investments in stocks are subject to market risk. There is no assurance or gaurantee that objectives of the products on this site will be achieved.</p>
            <Footer/>
        </>
    )
};

export default Multibagger;